import { Component, OnInit, NgZone, ViewChild, AfterContentInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import { MatRadioChange } from '@angular/material/radio';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {take} from 'rxjs/operators';
import { ExternalComponent } from '../external.component';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit {

  constructor(public parent: ExternalComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) { }

  showInvoiceVisualizer:boolean;
  CurrentInvoice: {[k: string]: any} = {};
  documentID:string;
  secret:string;
  IsStorno:boolean;
  partner: {[k: string]: any} = {};
  Products:any[];
  CompanyID:number;
  DocumentBodyLoading:boolean;

  ngOnInit(): void {
    this.getParamValues();
  }

  GetInvoice(invoiceID:string, UseInvoiceLanguage:boolean){

    var request = {
      ID:invoiceID,
      WithInfo:true,
      IsNewStorno:this.IsStorno,
      NewCopy:false,
      UseInvoiceLanguage:UseInvoiceLanguage,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetInvoice(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.FillInvoiceInfo(response["Invoice"]);
      }
    });
  }

  GetUser(id:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      id:id,
      WithDetails:true,
    };

    this.service.GetUser(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.User = response["User"];

        this.parent.User.Rights.AssignedCompanies.forEach(c => {
          if(c.ID == this.CompanyID){
           c.IsSelected = true;
           this.GetInvoice(this.documentID, true);
          }
          else{
            c.IsSelected = false;
          }
        });
      }
    });
  }

  getParamValues() {
    this.route.queryParams.subscribe(params => {   
      
      if(params['id']){
        this.documentID = params['id'];
      }

      if(params['secret']){
        this.secret = params["secret"];
      }

      if(params['CompanyID']){
        this.CompanyID = params["CompanyID"];
      }
     
    });

    if(this.documentID != undefined && this.documentID != null && this.secret != undefined && this.secret != null && this.CompanyID != undefined && this.CompanyID != null){
      this.GetUser(this.secret);
    }
  }

  FillInvoiceInfo(invoice:any){

    this.partner = {};
    this.CurrentInvoice = invoice;
    this.partner = this.CurrentInvoice.Client;

    this.Products = invoice.Products;
    this.IsStorno = invoice.IsStorno;
    this.parent.setLanguage(this.CurrentInvoice.Language.Name.toLowerCase());
    this.parent.translate.use(this.CurrentInvoice.Language.Name.toLowerCase());
    this.showInvoiceVisualizer = true;
    this.PushDocumentValuesToUpperTitle(this.CurrentInvoice);
  }

  PushDocumentValuesToUpperTitle(document:any){
    this.parent.DocumentStatus = document.DocumentStatus.Name;
    this.parent.DocumentDueDate = document.PaymentDueDateUI;
    this.parent.DocumentCurrency = document.Currency.Name;
    this.parent.DocumentPrice = document.Total.UITotalQtyPriceVAT.Integer + document.Total.UITotalQtyPriceVAT.Decimals;
  }

  PrintInvoice(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
    };

    this.DocumentBodyLoading = true;

    this.service.ExportInvoice(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }

      this.DocumentBodyLoading = false;
    });
  }

  download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

  ExportInvoice(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
    };

    this.DocumentBodyLoading = true;

    this.service.ExportInvoice(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }

      this.DocumentBodyLoading = false;
    });
  }

  printPage(name:string, html:string, ID:string) {
    var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
    'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
    + ' type="application/pdf"'
    + ' src="data:application/pdf;base64,'
    + escape(html)
    + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

}
